function FilterActions(actions, remove_cb) {
    this.map = {
        '#tag': TagFilterAction,
        '#calendar': DateFilterAction
    };
    var self = this;

    this.actions = actions.toArray()
        .map(function (item) {
            return self.actionsFactory(item);
        })
        .filter(function (item) {
            return !!item;
        });

    this.actions.map(function (item) {
        item.el
            .querySelector('.action__btn-close')
            .addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (remove_cb) {
                    remove_cb(item);
                }
            })
    });

}

FilterActions.prototype.render = function () {
    this.actions.map(function (item) {
        item.render();
    })
};

FilterActions.prototype.setData = function (state) {
    this.actions.map(function (item) {
        item.setData(state);
        item.render();
    })
};

FilterActions.prototype.actionsFactory = function (item) {
    if (this.map.hasOwnProperty(item.hash)) {
        return new this.map[item.hash](item);
    }
    return null;
};
